import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Checkbox, FormControlLabel } from '@mui/material'
import PropTypes from 'prop-types'

const FormInputCheckbox = ({
    color = 'primary',
    control,
    disabled = false,
    label,
    name,
    rules = null,
    size = 'medium',
}) => {
    const { t } = useTranslation()
    return (
        <FormControlLabel
            control={
                <Controller
                    control={control}
                    name={name}
                    render={({ field: { onChange, ref, value } }) => (
                        <Checkbox
                            checked={value}
                            color={color}
                            disabled={disabled}
                            inputRef={ref}
                            size={size}
                            onChange={(e) => onChange(e.target.checked)}
                        />
                    )}
                    rules={rules}
                />
            }
            label={t(label)}
        />
    )
}

FormInputCheckbox.propTypes = {
    control: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    rules: PropTypes.object,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
}

export default FormInputCheckbox
